// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info_box":"info_box-NLA8dBEE clearfix","comment":"comment-kn8C5inB","pic":"pic-1h8S6Gb-","v_logo":"v_logo-l8XBzia2","text":"text-VolBwWh2","time":"time-3r_tMoJE"};